import {createAsyncThunk} from '@reduxjs/toolkit';

import GeoJSON from 'ol/format/GeoJSON';
import request from '@apps-common/js-client/api/request';
import {API_MOSAICS_BASE_PATH} from '../config';

const format = new GeoJSON();

export const load = createAsyncThunk(
  'QUADS_LOAD',
  ({geometry, mosaic}, {rejectWithValue}) => {
    if (!geometry || !mosaic) {
      return;
    }

    return request
      .get(`${API_MOSAICS_BASE_PATH}/${mosaic.id}/quads`, {
        params: {
          bbox: format.readGeometry(geometry).getExtent().toString(),
        },
      })
      .then(res => ({
        quads: res.data.items,
        nextPage: res.data._links._next || null,
      }))
      .catch(err => rejectWithValue(err));
  }
);

export const loadNextPage = createAsyncThunk(
  'QUADS_LOAD_NEXT_PAGE',
  (url, {rejectWithValue}) => {
    return request
      .get(url)
      .then(res => ({
        quads: res.data.items,
        nextPage: res.data._links._next || null,
      }))
      .catch(err => rejectWithValue(err));
  }
);
